import type { ReactNode } from 'react';
import { useCallback } from 'react';

import type { FormAsyncComboboxProps } from '@/_components';
import { FormAsyncCombobox, PrimaryLink } from '@/_components';
import type { EmailTemplateQueryLinkerSchema } from '@/_pages/settings/email-templates/shared/schemas/email-templates-query-linker-schema';

import { useGetInvoiceEmailTemplatesMutation } from '../use-get-invoice-email-templates-mutation';

type InvoiceEmailTemplatesSelectProps = FormAsyncComboboxProps<EmailTemplateQueryLinkerSchema>;

export function InvoiceEmailTemplatesSelect({ disabled, ...props }: InvoiceEmailTemplatesSelectProps) {
  const getName = useCallback(
    (item?: EmailTemplateQueryLinkerSchema | null): ReactNode => {
      if (!item) {
        return '';
      }
      if (!disabled) {
        return item.name;
      }
      return (
        <PrimaryLink to="/settings/email-templates/$id" params={{ id: `${item.id}` }} state={{ naturalBack: true }}>
          {item.name}
        </PrimaryLink>
      );
    },
    [disabled]
  );

  return (
    <FormAsyncCombobox
      {...props}
      itemToString={getName}
      keyExtractor={(item) => item?.id?.toString?.() ?? null}
      useApi={useGetInvoiceEmailTemplatesMutation}
      disabled={disabled}
    />
  );
}
